import { render, staticRenderFns } from "./EditRepairTypeUser.vue?vue&type=template&id=542c1424"
import script from "./EditRepairTypeUser.vue?vue&type=script&lang=js"
export * from "./EditRepairTypeUser.vue?vue&type=script&lang=js"
import style0 from "./EditRepairTypeUser.vue?vue&type=style&index=0&id=542c1424&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports